export const testimonials = [
  {
    quote:
      'Vendía mis amigurumis a $2.000 y me rogaban descuento. Con la calculadora de costos me di cuenta que casi regalaba mi trabajo. Subí mis precios a $7.500 y vendí todo en una semana por Instagram.',
    name: 'Valentina M.',
    location: 'Rosario · Peluches Personalizados',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/b45efa96-61bc-4773-a5ea-e9fda994a79f.jpg',
  },
  {
    quote:
      'El tomo de Instagram me cambió todo. Antes publicaba y nadie preguntaba. Ahora mis Reels llegan a cientos de personas y tengo lista de espera. Nunca pensé que una foto con el celular podía hacer tanta diferencia.',
    name: 'Camila R.',
    location: 'Córdoba · Amigurumis Temáticos',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/3cb3bce4-7874-4a29-8165-93ae4978e41e.jpg',
  },
  {
    quote:
      'El tomo de Meta Ads es increíble. Con un presupuesto mínimo conseguí mis primeros pedidos de personas que no me conocían. Mi emprendimiento ya tiene identidad propia y agenda llena de encargos.',
    name: 'Rocío S.',
    location: 'Buenos Aires · Studio Tejido Boutique',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/90d50ad7-ad7b-48a3-bf4c-84ca943ecc39.jpg',
  },
];
